import React, { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";

// Components
import WordSubmit from "./components/forms/WordSubmit";
import NavBar from "./components/nav_bar/navBar";

export default function App() {
  const [words, setWords] = useState([{ word: "" }]);
  const [data, setData] = useState([{}]);
  const [letterList, setLetterList] = useState([]);
  const [wordListLength, setWordListLength] = useState();
  const [mustUseLetter, setMustUseLetter] = useState("");
  const [wordList, setWordList] = useState([])

  useEffect(() => {
    axios.get(`https://word-bank-db.herokuapp.com/db_pull`).then((res) => {
      console.log("RES", res);
      setData(res);
      setLetterList(res.data.letters);
      setWordListLength(res.data.list_len);
      setMustUseLetter(res.data.must_use);
      setWordList(res.data.word_list)
    });
  }, []);

  const addTodo = (text) => {
    const newTodos = [...words, { text }];
    setWords(newTodos);
  };

  return (
    <div className="app">
      <div className="app-wrapper">
        <NavBar />
        <div>
          <WordSubmit
            addTodo={addTodo}
            data={data}
            letterList={letterList}
            listLength={wordListLength}
            mustUse={mustUseLetter}
            words={words}
          />
        </div>
      </div>
    </div>
  );
}
